// extracted by mini-css-extract-plugin
export default {"container":"Project_container__c73e2","title":"Project_title__V0-80","project":"Project_project__iFYRf"};